import styled from '@emotion/styled';

export const StyledAddTimeButton = styled.button`
  width: 100%;
  font-size: 14px;
  background: #d8d8d8;
  border-radius: 10px;
  padding: 6px 18px;
`;
